"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PeaksToggleActions = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const cheminfo_font_1 = require("cheminfo-font");
const ActiveButton_1 = __importDefault(require("../../elements/ActiveButton"));
const style = {
    margin: '0 2px',
};
function PeaksToggleActions(props) {
    const { disbale, displayingMode, showPeaks, onShowToggle, onDisplayingModeToggle, } = props;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ActiveButton_1.default, { style: style, popupTitle: showPeaks ? 'Hide peaks' : 'Show peaks', popupPlacement: "right", onClick: onShowToggle, disabled: disbale, value: showPeaks, children: (0, jsx_runtime_1.jsx)(cheminfo_font_1.SvgNmrPeaks, { style: { pointerEvents: 'none', fontSize: '12px' } }) }), (0, jsx_runtime_1.jsx)(ActiveButton_1.default, { style: style, popupTitle: displayingMode === 'spread' ? 'Single Mode' : 'Spread mode', popupPlacement: "right", onClick: onDisplayingModeToggle, disabled: disbale, value: displayingMode === 'spread', children: (0, jsx_runtime_1.jsx)(cheminfo_font_1.SvgNmrPeaksTopLabels, { style: { pointerEvents: 'none', fontSize: '12px' } }) })] }));
}
exports.PeaksToggleActions = PeaksToggleActions;
